import React, { PureComponent, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { Redirect } from 'react-router';
import { decamelizeKeys } from 'humps';

import { callApi } from '../../middleware/api';
import UserForm from './UserForm';
import CompanyForm from './CompanyForm';
import { SubmissionError } from 'redux-form'

import './Registration.scss';

const FORM_INVALID = 400;
const USER_CREATED = 201;
const USER_NOT_FOUND = 404;


export default class Registration extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    }

    this.submitUser = this.submitUser.bind(this);
    this.sumbitCompany = this.sumbitCompany.bind(this);
  }

  submitUser(values) {
    const user = decamelizeKeys(values);
    return callApi('registration/', undefined, "POST", {user}).then(
      resp => this.setState({success: true}),
      ({response, json}) => {
        switch (response.status) {
          // user form has errors
          case FORM_INVALID:
            const { nonFieldErrors: _error, ...errors } = json;
            throw new SubmissionError({...errors, _error});

          // user not found, proceed with company form
          case USER_NOT_FOUND:
            this.setState({user})
            break;

          default:
            // @TODO error
            break;
        }
      }
    );
  }

  sumbitCompany(values) {
    const { user } = this.state;
    const company = decamelizeKeys(values);
    return callApi('registration/', undefined, "POST", {user, company}).then(
      resp => this.setState({success: true}),
      ({response, json}) => {
          const { nonFieldErrors: _error, ...errors } = json;
          throw new SubmissionError({...errors, _error});
      }
    );
  }

  render() {
    const { user, success } = this.state;
    
    if (success) {
      return <Redirect to="/reset/success/" />
    }

    return (
      <div className="container mt-5">
        <DocumentTitle title="Reģistrācija - e-BML" />
        <h1>Reģistrācija</h1>
        { user 
          ? (<div className="row mt-4">
              <div className="col-10">
                <h2>Uzņēmums</h2>
                <CompanyForm
                  onSubmit={this.sumbitCompany}
                  initialValues={{
                    addresses: [{ type: 'both'}],
                    accounts: [{}]
                  }}
                />
              </div>
            </div>)
          : (<div className="row mt-4">
              <div className="col-10">
                <h2>Lietotājs</h2>
                <UserForm onSubmit={this.submitUser}/>
              </div>
            </div>)
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Registration/index.js